import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { OwnershipLevel } from '@fitness-force/enum';
import { AppErrors, ConflictError, NotFoundError } from '@fitness-force/models';;
import type { CreateWhatsAppSenderConfigurationRequest, ListWhatsAppSenderConfigurationMasterResponse, WhatsAppSenderConfigurationMasterResponse } from '@fitness-force/models';
import { environment } from '@fitness-force/environments';
import { map, catchError, throwError, Observable } from 'rxjs';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';

@Injectable({
  providedIn: 'root'
})
export class WhatsappSenderConfigService {
  private http = inject(HttpClient);

  BASE_URL: string = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };


  GetWhatsAppSenderConfig(tenantId: number,configId: number): Observable<WhatsAppSenderConfigurationMasterResponse> {
    return this.http.get<WhatsAppSenderConfigurationMasterResponse>(
        environment.BASE_URL + CONST_URL_SEGEMENTS.WHATSAPP_CONFIG.GET_WHATSAPP_CONFIG
          .replace('{tenant_id}', tenantId.toString())
          .replace('{config_id}', configId.toString()),
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  CreateWhatsAppSenderConfig(tenantId: number,createWhatsAppSenderRequest: CreateWhatsAppSenderConfigurationRequest) {
    return this.http.post(environment.BASE_URL + CONST_URL_SEGEMENTS.WHATSAPP_CONFIG.ENABLE_WHATSAPP_CONFIG
      .replace('{tenant_id}', tenantId.toString()),createWhatsAppSenderRequest,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  ListWhatsAppSenderConfig(tenantId: number): Observable<ListWhatsAppSenderConfigurationMasterResponse> {
    return this.http.get<ListWhatsAppSenderConfigurationMasterResponse>(
        environment.BASE_URL + CONST_URL_SEGEMENTS.WHATSAPP_CONFIG.GET_WHATSAPP_CONFIGS
          .replace('{tenant_id}', tenantId.toString()),
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  ListWhatsAppSenderConfigByOwnership(ownership:OwnershipLevel, tenantId:number, franchiseGroupId:number): Observable<ListWhatsAppSenderConfigurationMasterResponse> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.COMPANIES.GET_WHATSAPP_CONFIGS;
        break;
      case OwnershipLevel.Franchise:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.FRANCHISE_GROUP.GET_WHATSAPP_CONFIG
          .replace('{franchise_group_id}', franchiseGroupId.toString());
        break;
      case OwnershipLevel.Tenant:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.WHATSAPP_CONFIG.GET_WHATSAPP_CONFIGS
          .replace('{tenant_id}', tenantId.toString());
        break;
      default:
        break;
    }
    return this.http.get<ListWhatsAppSenderConfigurationMasterResponse>(url,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
  
}
